import React from "react";
import Icons from "../../components/Icons";
import BlueTag from "../../ui/BlueTag";
import Heading from "../../ui/Heading";
import Paragraph from "../../ui/Paragraph";
import Card from "./Card";

const OurServices = ({ serviceList }) => {
  return (
    serviceList && (
      <div className="bg-white pt-10 sm:pt-14 md:pt-20 lg:pt-24 pb-14 sm:pb-16 md:pb-24 lg:pb-28 xl:pb-[140px]">
        <div className="container  mx-auto max-lg:px-3.5 max-md:px-6">
          <div className="flex max-xl:flex-col flex-row-reverse gap-y-8 gap-x-[57px] items-center">
            <div className="max-lg:max-w-[714px] xl:max-w-[505px] w-full mx-auto">
              <BlueTag>Our Services</BlueTag>
              <Heading className="pt-1 max-xl:mx-auto xl:max-w-[505px]">
                {serviceList.title}
              </Heading>
              {serviceList.description.map((detail, index) => (
                <Paragraph
                  key={index}
                  className="pt-3 max-w-[778px] xl:max-w-[500px]"
                >
                  {detail}
                </Paragraph>
              ))}

              {serviceList.listBadges && (
                <div className="inline-flex flex-col gap-y-4 pt-5">
                  {serviceList.listBadges.map((obj, index) => (
                    <div
                      key={index}
                      className="inline-flex items-center  gap-x-1.5"
                    >
                      <Icons className="min-w-[18px]" icon="blue-check-mark" />
                      <p className="font-semibold text-sm !leading-130 text-custom-dark-blue">
                        {obj}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="flex h-full w-full xl:max-w-[583px] md:max-h-[462px]">
              <Card detail={serviceList.second} />
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default OurServices;
